import { AppPageComponent } from '../../shared/ui';
import { Component, OnInit, ViewChild } from '@angular/core';
import {
    ProfitLossFilter,
    ProfitLossExpenseFilter,
    ProfitLossFilterSheetComponent,
    ProfitSummary,
    ProfitLocationSale,
    ProfitProductSale,
    ProfitEmployeeSale,
    ProfitSummaryService,
    ProfitLocationSaleService,
    ProfitProductSaleService,
    ProfitEmployeeSaleService
}
from '../shared';

import {
    LossExpenseCategory,
    LossCostSale,
    LossInventoryLosses,
    LossPayroll,
    LossSummary,
    LossExpenseCategoryService,
    LossCostSaleService,
    LossInventoryLossesService,
    LossPayrollService
}
from '../shared';

import { DateRange, HeaderAction, TopLevelComponent } from '../../shared';
import { FormGroup } from '@angular/forms';
import {
    Store,
    StoreHelper,
    UserService,
} from '../../shared/services';



@Component({
    template: require('./profit-loss-index.component.pug')
})
export class ProfitLossIndexComponent extends TopLevelComponent {
    @ViewChild(AppPageComponent) appPage;
    @ViewChild(ProfitLossFilterSheetComponent) filterSheet;


    fg = new FormGroup({});
    loading = true;
    authorized = true;

    private _searchAction = { id: 'calendar', icon: 'calendar' };
    private _profitLossFilter: ProfitLossFilter;
    private _profitLossExpenseFilter: ProfitLossExpenseFilter;
    private _filterReady: boolean = false;
    private isProfit = true;

    private profitSummary: ProfitSummary;
    private isLoadProfitSummary: boolean = false;

    private locationSales: Array<ProfitLocationSale>;
    private isLoadProfitLocationSales: boolean = false;

    private employeeSales: Array<ProfitEmployeeSale>;
    private isLoadProfitEmployee: boolean = false;

    private productSales: Array<ProfitProductSale>;
    private isLoadProfitproduct: boolean = false;

    public existNumbersInProfitSummary: boolean = false;

    /*Loss variables */
    private lossSummary: LossSummary;
    private lossExpenseCategories: Array<LossExpenseCategory>;
    private totalLossExpenseCategory: number;
    private isLoadLossExpenseCategory: boolean = false;

    private lossCostSales: Array<LossCostSale>;
    private totalLossCostSale: number;
    private isLoadLossCostSale: boolean = false;


    private lossInventoryLosses: Array<LossInventoryLosses>;
    private totalLossInventoryLosses: number;
    private isLoadLossInventoryLosses: boolean = false;

    private lossPayrolls: Array<LossPayroll>;
    private totalLossPayroll: number;
    private isLoadLossPayroll: boolean = false;

    constructor(
        private profitSummaryService: ProfitSummaryService,
        private profitLocationSaleService: ProfitLocationSaleService,
        private profitProductSaleService: ProfitProductSaleService,
        private profitEmployeeSaleService: ProfitEmployeeSaleService,
        private lossExpenseCategoryService: LossExpenseCategoryService,
        private lossCostSaleService: LossCostSaleService,
        private lossInventoryLossesService: LossInventoryLossesService,
        private lossPayrollService: LossPayrollService,
        store: Store,
        storeHelper: StoreHelper,
        userService: UserService
    ) {
        super(store, storeHelper, userService);

        // set title and actions
        this.headerTitle = 'Profit/Loss';
        this.headerActions = [this._searchAction];
        this.subscribeToHeaderActions(this._reactToHeaderAction);
    }


    onFilterChanged(filter: ProfitLossFilter) {

        this._CloseFilterSheet();
        this._profitLossFilter = filter;
        this._updateIsProfit();
        this._updateProfitLossFilter();

        if (this.isProfit) {
            this._loadProfit();
        }
        else {
            this._loadLoss();
        }

    }

    private _CloseFilterSheet() {

        if (this._filterReady) {
            this.filterSheet.toggle();
        }

        this._filterReady = true;
    }

    private _reactToHeaderAction(action: HeaderAction) {
        if (action.id === this._searchAction.id && this.authorized) {
            this.filterSheet.toggle();
        }
    }

    private _updateIsProfit() {
        this.isProfit = this._profitLossFilter.optionSelected === 'Profits';
    }

    /*LOAD PROFIT */
    private _loadProfit() {
        this.empty = false;
        this._loadIconLoading();

        if (this._profitLossFilter.locationsSelection.locations.length > 0) {
            this._loadProfitSummary();
            this._loadLocationSaleList();
            this._loadProductSaleList();
            this._loadEmployeeSaleList();

        } else {
            this._resetProfitData();
            this._closeIconLoading();
            this.empty = true;
            this._showFilterSheet();
        }

    }

    private _updateProfitLossFilter() {
        // If we dont have locations selected, then take all the locations from  the region
        if (this._profitLossFilter.locationsSelection.locations.length < 1) {
            this._profitLossFilter.locationsSelection.locations = this._profitLossFilter.locationsSelection.region.locations;
        }
    }

    private _loadProfitSummary() {
        this.isLoadProfitSummary = false;

        this.loading = true;
        this.profitSummaryService.getProfitSummary(this._profitLossFilter)
            .subscribe(profitSummary => {
                this.profitSummary = profitSummary;
            },
            err => {
                
                this.authorized = this.userService.userHasAccess(err);
                this.appPage.deactivatePreloader();
                this.loading = false;
                this._resetSummary();
            },
            () => {
                this.loading = false;
                this._LoadProfitMargin();
            });
    }

    private _LoadProfitMargin() {
        this.profitSummaryService.getProfitMargin(this._profitLossFilter)
            .subscribe(margin => {
                this.profitSummary.margin = margin;
                this.isLoadProfitSummary = true;
                this._checkIfApplyCloseIconLoadingInProfit();
            }, (error: any) => this._resetSummary());
    }

    private _loadLocationSaleList() {
        this.isLoadProfitLocationSales = false;

        this.profitLocationSaleService.getLocationSales(this._profitLossFilter)
            .subscribe(locations => {
                this.locationSales = locations;
                this.isLoadProfitLocationSales = true;
                this._checkIfApplyCloseIconLoadingInProfit()

            }, (error: any) => this._resetLocationSales());
    }

    private _loadProductSaleList() {
        this.isLoadProfitproduct = false;

        this.profitProductSaleService.getProductSaleList(this._profitLossFilter)
            .subscribe(sales => {
                this.productSales = sales;
                this.isLoadProfitproduct = true;
                this._checkIfApplyCloseIconLoadingInProfit();
            }, (error: any) => this._resetProductSales());
    }

    private _loadEmployeeSaleList() {
        this.isLoadProfitEmployee = false;

        this.profitEmployeeSaleService.getEmployeeSaleList(this._profitLossFilter)
            .subscribe(sales => {
                this.employeeSales = sales;
                this.isLoadProfitEmployee = true;
                this._checkIfApplyCloseIconLoadingInProfit();
            }, (error: any) => this._resetEmployeeSales());
    }

    private _ValidateExistANumbersInProfitSummaryDifferentZero() {
        if (this.profitSummary.gross === 0
            && this.profitSummary.margin === 0
            && this.profitSummary.net === 0
            && this.profitSummary.netProfit === 0
            && this.profitSummary.tax === 0) {
            return false;
        }
        return true;
    }

    private _resetProfitData() {
        this._resetSummary();
        this._resetLocationSales();
        this._resetProductSales();
        this._resetEmployeeSales();
        this.existNumbersInProfitSummary = false;
    }

    private _resetSummary() {
        this.profitSummary = new ProfitSummary(null);
    }

    private _resetLocationSales() {
        this.locationSales = [];
    }

    private _resetProductSales() {
        this.productSales = [];
    }

    private _resetEmployeeSales() {
        this.employeeSales = [];
    }

    private _verifyIfEmptyProfitData() {
        this.empty = !this.existNumbersInProfitSummary;
    }

    private _checkIfApplyCloseIconLoadingInProfit(): void {

        if (this.isLoadProfitEmployee && this.isLoadProfitLocationSales && this.isLoadProfitproduct && this.isLoadProfitSummary) {
            this.profitSummary.UpdateNetProfit();
            this.existNumbersInProfitSummary = this._ValidateExistANumbersInProfitSummaryDifferentZero();
            this._verifyIfEmptyProfitData();
            this._closeIconLoading();

            if (this.empty) {
                this._showFilterSheet();
            }
        }
    }
    /*END LOAD PROFIT */


    /*LOAD LOSS */

    private _loadLoss() {
        this.empty = false;
        this._loadIconLoading();

        if (this._profitLossFilter.locationsSelection.locations.length > 0) {
            this._loadExpensesList();
            this._loadCostSaleList();
            this._loadInventoryLossesList();
            this._loadPayrollList();
        } else {
            this._resetLossData();
            this._closeIconLoading();
            this.empty = true;
            this._showFilterSheet();
        }
    }

    private _loadExpensesList() {

        this._profitLossExpenseFilter = new ProfitLossExpenseFilter(this._profitLossFilter.date, this._profitLossFilter.locationsSelection);
        this.isLoadLossExpenseCategory = false;

        if (this._isAplicableExpenses()) {

            this.lossExpenseCategoryService.getExpensesByCategoryList(this._profitLossExpenseFilter)
                .subscribe(expensesCategories => {
                    this.lossExpenseCategories = expensesCategories;
                    this._updateTotalLossCategory();
                    this.isLoadLossExpenseCategory = true;
                    this._checkIfApplyCloseIconLoadingInLoss();
                }, (error: any) => this._resetExpensesCategories());

        } else {
            this._resetExpensesCategories();
            this.isLoadLossExpenseCategory = true;
        }
    }

    private _loadCostSaleList() {
        this.isLoadLossCostSale = false;

        this.lossCostSaleService.getProductCostSaleList(this._profitLossFilter)
            .subscribe(costSales => {
                this.lossCostSales = costSales;
                this._updateTotalLossCostSale();
                this.isLoadLossCostSale = true;
                this._checkIfApplyCloseIconLoadingInLoss();
            }, (error: any) => this._resetCostSales());
    }

    private _loadInventoryLossesList() {
        this.isLoadLossInventoryLosses = false;

        this.lossInventoryLossesService.getProductCostSaleList(this._profitLossFilter)
            .subscribe(inventoryLosses => {
                this.lossInventoryLosses = inventoryLosses;
                this._updateTotalInventoryLosses();
                this.isLoadLossInventoryLosses = true;
                this._checkIfApplyCloseIconLoadingInLoss();
            }, (error: any) => this._resetInventoryLosses());
    }

    private _loadPayrollList() {
        this.isLoadLossPayroll = false;

        this.lossPayrollService.getEmployeePayrollsList(this._profitLossFilter)
            .subscribe(payrolls => {
                this.lossPayrolls = payrolls;
                this._updateTotalLossPayroll();
                this.isLoadLossPayroll = true;
                this._checkIfApplyCloseIconLoadingInLoss();
            }, (error: any) => this._resetPayrolls());
    }


    private _updateTotalLossCategory() {
        this.totalLossExpenseCategory = 0;

        this.lossExpenseCategories.forEach(element => {
            this.totalLossExpenseCategory += element.amount;
        });
    }

    private _updateTotalLossCostSale() {
        this.totalLossCostSale = 0;

        this.lossCostSales.forEach(element => {

            this.totalLossCostSale += element.cost;
        });
    }

    private _updateTotalInventoryLosses() {
        this.totalLossInventoryLosses = 0;

        this.lossInventoryLosses.forEach(element => {
            this.totalLossInventoryLosses += element.cost;
        });

    }

    private _updateTotalLossPayroll() {
        this.totalLossPayroll = 0;

        this.lossPayrolls.forEach(element => {
            this.totalLossPayroll += element.salary;
        });
    }

    private _resetLossData() {
        this._resetExpensesCategories();
        this._resetPayrolls();
        this._resetInventoryLosses();
        this._resetCostSales();
        this._resetLossSummary();
    }

    private _resetLossSummary() {
        this.lossSummary = new LossSummary(0, 0, 0, 0);
    }

    private _resetExpensesCategories() {
        this.totalLossExpenseCategory = 0;
        this.lossExpenseCategories = [];
    }

    private _resetPayrolls() {
        this.totalLossPayroll = 0;
        this.lossPayrolls = [];
    }

    private _resetInventoryLosses() {
        this.totalLossInventoryLosses = 0;
        this.lossInventoryLosses = [];
    }

    private _resetCostSales() {
        this.totalLossCostSale = 0;
        this.lossCostSales = [];
    }


    private _isAplicableExpenses(): boolean {

        let locationFilter = this._profitLossFilter.locationsSelection;

        return (!locationFilter.region ||
            (locationFilter.region.id > 0 && locationFilter.region.locations.length === locationFilter.locations.length));
    }


    private _verifyIfEmptyLossData() {
        this.empty = this.lossSummary.total === 0;
    }

    private _createLossSummary() {
        this.lossSummary = new LossSummary(
            this.totalLossExpenseCategory,
            this.totalLossCostSale,
            this.totalLossInventoryLosses,
            this.totalLossPayroll);
    }
    /*End Loss */


    /*Icon Loading functions */
    private _loadIconLoading() {
        this.appPage.activatePreloader();
    }

    private _closeIconLoading() {
        this.appPage.deactivatePreloader();
    }

    private _checkIfApplyCloseIconLoadingInLoss(): void {

        if (this.isLoadLossExpenseCategory && this.isLoadLossCostSale && this.isLoadLossInventoryLosses && this.isLoadLossPayroll) {
            this._createLossSummary();
            this._closeIconLoading();
            this._verifyIfEmptyLossData();

            if (this.empty) {
                this._showFilterSheet();
            }
        }
    }



    /*Empty message */

    /*Show Filter Sheew */
    private _showFilterSheet() {
        setTimeout(() => this.filterSheet.toggle(), 1500);

        this._filterReady = true;
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/accounting/profit-loss/profit-loss-index.component.ts